import script from "./CodeGenerator.vue?vue&type=script&setup=true&lang=js"
export * from "./CodeGenerator.vue?vue&type=script&setup=true&lang=js"

import "./CodeGenerator.vue?vue&type=style&index=0&id=eebeb34e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eebeb34e"]])

export default __exports__